import { Move } from 'generate/types';

export function parseToDriverMessage(data: Partial<Move>) {
	let res = '';
	Object.entries(data).map(([k, v]) => (res += `${k}: ${v} \n`));
	return res;
}
